import React from "react";
import {NavLink} from "react-router-dom";

const Header = () => (
  <header className="cp_global-header">
    <div className="container">
      <NavLink exact={true} activeClassName={'active'} to={`${process.env.PUBLIC_URL}/`}>Home</NavLink>
      <NavLink activeClassName={'active'} to={`${process.env.PUBLIC_URL}/work`}>Work</NavLink>
      <NavLink activeClassName={'active'} to={`${process.env.PUBLIC_URL}/clientlist`}>Client List</NavLink>
    </div>
  </header>
)

export default Header
